import { render, staticRenderFns } from "./DatePickerBackDate.vue?vue&type=template&id=020a95f2"
import script from "./DatePickerBackDate.vue?vue&type=script&lang=js"
export * from "./DatePickerBackDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports